import React from "react";
import { HelpCircle } from "lucide-react";
import Modal from "../Modal/Modal";

/* =======================
   Styles
======================= */
import styles from "./ConfirmModal.module.scss";

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure you want to submit?",
}) => {
  if (!open) return null;

  return (
    <Modal title="Confirmation" onClose={onClose}>
      <div className={styles["admin-con-modal__content"]}>
        {/* Modern Icon Wrapper */}
        <div className={styles["admin-con-modal__icon-wrapper"]}>
          <HelpCircle size={32} strokeWidth={2.5} />
        </div>

        {/* Dynamic Title (using the passed title prop for logic consistency) */}
        <h3 className={styles["admin-con-modal__title"]}>{title}</h3>

        {/* Modern Action Buttons (Borderless/Shadowed) */}
        <div className={styles["admin-con-modal__actions"]}>
          <button
            className={`${styles["admin-con-modal__btn"]} ${styles["admin-con-modal__btn--cancel"]}`}
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className={`${styles["admin-con-modal__btn"]} ${styles["admin-con-modal__btn--confirm"]}`}
            onClick={onConfirm}
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
